import { CbhFeatureFlag } from "@src/appV2/FeatureFlags";
import { INotification } from "src/modules/myAccount/types";

export const TOGGLE_BUTTON = {
  edit: "Edit information",
  save: "Save changes",
};

export const HEADINGS = {
  personalInfo: "Personal Information",
  roles: "Roles",
  notification: "Notification Preferences",
};

export const NotificationDetails: Record<string, INotification> = {
  allNotifications: {
    description: "All notifications",
    email: "All",
    sms: "All",
    push: false,
  },
  pushNotification: {
    description: "Send me web-based push notifications",
    email: false,
    sms: false,
    push: true,
    web_push: "web_push",
  },
  assignment: {
    description: "Notify me when a worker books a shift",
    email: "assignmentEmail",
    sms: "assignmentSMS",
    push: true,
  },
  shiftUnassignment: {
    description: "Notify me when a worker cancels a shift",
    email: "shiftUnassignmentEmail",
    sms: "shiftUnassignmentSMS",
    push: true,
  },
  workerEta: {
    description: "Notify me if a worker is going to be late for their shift",
    email: "workerEtaEmail",
    sms: "workerEtaSMS",
    push: false,
  },
  chatMessages: {
    description: "Notify me when a worker sends a chat message",
    email: "chatMessages",
    sms: "chatMessages",
    push: false,
  },
  invoice: {
    description: "Send me generated invoices (weekly)",
    email: "invoiceEmail",
    sms: false,
    push: false,
  },
  rateNegotiation: {
    description: "Send me rate negotiation updates",
    email: "rateNegotiationEmail",
    sms: false,
    push: false,
    flag: CbhFeatureFlag.RATE_NEGOTIATION_ACTIVATION,
  },
  CDPH530: {
    description: "Send me digital CDPH-530 copies (daily)",
    email: "dailyCDPH530Recap",
    sms: false,
    push: false,
    flag: CbhFeatureFlag.CALIFORNIA_TIMESHEET,
  },
  ewtrEmails: {
    description: "Send worked break payment request notifications",
    email: "ewtrEmails",
    sms: false,
    push: false,
  },
  wleReplacement: {
    description: "Notify me when a worker left early and a replacement is needed",
    email: "wleReplacementEmail",
    sms: false,
    push: false,
  },
  candidateApplyEmail: {
    description: "Notify me when a candidate applies for a placement",
    email: "candidateApplyEmail",
    sms: false,
    push: false,
    flag: CbhFeatureFlag.PLACEMENTS_ACCESS_CONTROL_ROLLOUT,
  },
  interviewAttendanceConfirmed: {
    description: "Notify me when a candidate confirms their interview attendance",
    email: "interviewAttendanceConfirmed",
    sms: false,
    push: false,
    flag: CbhFeatureFlag.PLACEMENTS_ACCESS_CONTROL_ROLLOUT,
  },
  jobScheduleUpdates: {
    description: "Ask for job schedule updates",
    email: "jobScheduleUpdatesEmail",
    sms: "jobScheduleUpdatesSMS",
    push: false,
    flag: CbhFeatureFlag.PLACEMENTS_ACCESS_CONTROL_ROLLOUT,
  },
  upcomingInterviewUpdates: {
    description: "Send upcoming interview updates",
    email: "upcomingInterviewUpdatesEmail",
    sms: "upcomingInterviewUpdatesSMS",
    push: false,
    flag: CbhFeatureFlag.PLACEMENTS_ACCESS_CONTROL_ROLLOUT,
  },
  interviewWorkerETA: {
    description: "Interview worker ETA",
    email: false,
    sms: "interviewWorkerETASMS",
    push: false,
    flag: CbhFeatureFlag.PLACEMENTS_ACCESS_CONTROL_ROLLOUT,
  },
};

export const BATCH_DESCRIPTIONS =
  "We will send you a daily summary for this notification, at the time of your choice.";

export const BATCH_HOURS = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
export const BATCH_MERIDIEM = ["am", "pm"];

export const FORM_DETAILS = {
  firstName: {
    label: "First Name",
    name: "firstName",
    errorMessage: "Please enter a first name.",
  },
  lastName: {
    label: "Last Name",
    name: "lastName",
    errorMessage: "Please enter a last name.",
  },
  email: {
    label: "Email",
    name: "email",
    errorMessage:
      "Please enter an email. After editing an email, you must log out and log back in with the new email address.",
    help: "After editing an email, you must log out and log back in with the new email address.",
  },
  phone: {
    label: "Mobile",
    name: "phone",
    errorMessage: "Please enter a mobile number.",
  },
  workplacePhone: {
    label: "Landline",
    name: "workplacePhone",
    errorMessage: "Please enter a valid landline number.",
  },
  designation: {
    label: "Job Title",
    name: "designation",
    errorMessage: "Please enter a designation.",
  },
};
